<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="designDialogClose"
        :visible.sync="dialogDesignVisible"
        width="1300px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-main>
            <el-form :inline="true" :model="taskForm" ref="taskForm">
                <el-form-item :label="$t('pgCommon.TASK_KEY')" prop="taskKey">
                    <td-input v-model="taskForm.taskKey" :readonly="true"></td-input>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.TASK_NAME')" prop="taskName">
                    <td-input v-model="taskForm.taskName" :readonly="true"></td-input>
                </el-form-item>
                <el-form-item>
                    <td-button type="button" @click="btnPreview">{{ $t('pgCommon.PREVIEW_PAGE') }} </td-button>
                </el-form-item>
            </el-form>
            <el-row>
                <el-col>
                    <td-button type="button" @click="btnAddGroupElement">{{ $t('pgCommon.ADD_ELEMENT') }} </td-button>
                    <td-button type="button" @click="btnBatchDelElement" :loading="batchDeleteLoading">{{ $t('pgCommon.DELETE_BATCH') }} </td-button>
                    <td-button type="primary" @click="setSeriesButton">{{ $t('pgCommon.SET_SERIES_BUTTON') }} </td-button>
                </el-col>
            </el-row>
            <!-- 加载表格 -->
            <el-row>
                <el-col>
                    <td-table
                        :columns="columns"
                        :dataSource="tableData"
                        rowKey="sId"
                        :hasPage="false"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                        ref="tableInfo"
                        @getSortData="getSortData"
                        :hasDraggable="true"
                    ></td-table>
                </el-col>
            </el-row>
            <!-- 加载扩展元素dialog -->
            <dialog-GroupElement
                v-if="dialogGroupElementVisible"
                :isAddData="isAddElementData"
                :dialogVisible="dialogGroupElementVisible"
                :editItem="editItem"
                :groupId="groupId"
                :templateId="modelStr"
                :templateKey="modelKey"
                :taskKey="taskKey"
                :taskName="taskName"
                :elementTitle="elementTitle"
                :maxExtendOrder="maxExtendOrder"
                @elementDialogClose="elementDialogClose"
                @callbackQuery="callbackQuery"
            ></dialog-GroupElement>
            <!-- 加载效果预览dialog -->
            <dialog-Preview
                v-if="dialogPreviewVisible"
                :designParam="designParam"
                :dialogVisible="dialogPreviewVisible"
                :templateKey="templateKey"
                :previewTitle="previewTitle"
                :taskKey="taskKey"
                :groupElementValue="groupElementValue"
                @previewDialogClose="previewDialogClose"
            ></dialog-Preview>
            <setSeriesButtonDialog
                v-if="dialogetSeriesButtonVisible"
                :designParam="designParam"
                :templateKey="templateKey"
                :taskForm="taskForm"
                :dialogetSeriesButtonVisible="dialogetSeriesButtonVisible"
                @setSeriesButtonDialogColse="setSeriesButtonDialogColse"
            >
            </setSeriesButtonDialog>
        </el-main>
        <span slot="footer">
            <td-button @click="designDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import extendGroupApi from './../assets/api.js';
import Api from './../assets/api.js';
// import dialogGroupInfo from './components/dialogGroupInfo.vue';
import dialogGroupElementInfo from './addElementDialog.vue';
import dialogPreviewInfo from './previewDialog.vue';
import setSeriesButtonDialog from './setSeriesButtonDialog.vue';
export default {
    props: ['title', 'dialogDesignVisible', 'templateKey', 'templateId', 'designParam'],
    // 初始化渲染
    components: {
        // 'dialog-Group': dialogGroupInfo,
        'dialog-GroupElement': dialogGroupElementInfo,
        'dialog-Preview': dialogPreviewInfo,
        setSeriesButtonDialog: setSeriesButtonDialog
    },
    created() {
        this.listQuery();
    },
    data() {
        return {
            dialogetSeriesButtonVisible: false,
            setSeriesLoading: false,
            permissionsAdd: ['workflow:add'],
            permissionsEdit: ['workflow:edit'],
            permissionsView: ['workflow:view'],
            permissionsDel: ['workflow:del'],
            permissionsImport: ['workflow:import'],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            maxExtendOrder: 1,
            listHeight: window.innerHeight - 245,
            addLoading: false,
            batchDeleteLoading: false,
            dialogGroupVisible: false,
            dialogGroupElementVisible: false,
            dialogPreviewVisible: false,
            isAddData: true, // 是否为添加数据
            isAddElementData: true, // 是否为添加扩展组元素数据
            editItem: '',
            editGroupItem: '',
            groupFlg: '', //扩展组标识
            groupId: '', //扩展组ID
            groupElementValue: {}, //扩展组元素值
            taskForm: {
                taskKey: this.designParam.taskKey,
                taskName: this.designParam.taskName
            },
            tableData: [],
            //单列表对象
            columnObj: {
                id: 'sId',
                prop: 'sName'
            },
            columns: [
                {
                    prop: 'sViewName',
                    label: this.$t('pgCommon.ELEMENT_NAME'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'iOrder',
                    align: 'center',
                    tableWidth: '90',
                    label: this.$t('pgCommon.SHOW_ORDER')
                },
                {
                    prop: 'iColNum',
                    label: this.$t('pgCommon.ELEMENT_LAYOUT'),
                    align: 'center',
                    tableWidth: '90',
                    render: (createElement, params) => {
                        let rowName = this.$t('pgCommon.A_ROW');

                        if (params.row.iColNum === 12) {
                            rowName = this.$t('pgCommon.B_ROW');
                        } else if (params.row.iColNum === 8) {
                            rowName = this.$t('pgCommon.C_ROW');
                        } else if (params.row.iColNum === 6) {
                            rowName = this.$t('pgCommon.D_ROW');
                        }
                        return createElement('span', rowName);
                    }
                },
                {
                    prop: 'iHidden',
                    label: this.$t('pgCommon.ELEMENT_HIDDEN'),
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        let rowName = '';
                        switch (Number(params.row.iHidden)) {
                            case 0:
                                rowName = this.$t('pgCommon.YES');
                                break;
                            case 1:
                                rowName = this.$t('pgCommon.NOT');
                        }
                        return createElement('span', rowName);
                    }
                },
                {
                    prop: 'iNeeded',
                    label: this.$t('pgCommon.ELEMENT_NOT_NULL'),
                    align: 'center',
                    tableWidth: '80',
                    render: (createElement, params) => {
                        let rowName = this.$t('pgCommon.YES');

                        if (Number(params.row.iNeeded) === 1) {
                            rowName = this.$t('pgCommon.NOT');
                        }
                        return createElement('span', rowName);
                    }
                },

                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEditGroupElement(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.deleteGroupElement(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    methods: {
        setSeriesButtonDialogColse() {
            this.dialogetSeriesButtonVisible = false;
        },
        //设置流程条件按钮
        setSeriesButton() {
            this.setSeriesLoading = true;
            this.dialogetSeriesButtonVisible = true;
        },
        //效果预览
        btnPreview() {
            // this.groupFlg = this.templateKey + ':' + this.taskForm.taskKey + ':' + vPinyin.chineseToPinYin(this.taskForm.taskName);
            this.taskKey = this.taskForm.taskKey;
            this.groupFlg = this.templateKey + ':' + this.taskForm.taskKey;
            this.previewTitle = 'pgCommon.PREVIEW_PAGE'; // 标题
            let content = {
                groupFlg: this.groupFlg
            };
            Api.queryExtendValue(content, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/queryExtendValue', response.data.statusMessage);
                    this.submitLoading = false;
                    return;
                }
                if (!this.$util.isEmpty(response.data.content)) {
                    this.groupElementValue = JSON.parse(response.data.content);
                }
                this.dialogPreviewVisible = true;
            });
        },
        //添加扩展组元素
        btnAddGroupElement() {
            this.elementTitle = 'pgCommon.ADD_ELEMENT'; // 标题
            this.isAddElementData = true;
            this.groupId = this.templateKey + ':' + this.taskForm.taskKey;
            this.modelStr = this.templateId;
            this.modelKey = this.templateKey;
            this.taskKey = this.taskForm.taskKey;
            this.taskName = this.taskForm.taskName;
            let param = {
                groupId: this.templateKey + ':' + this.taskForm.taskKey
            };
            extendGroupApi.getMaxExtendOrder(param, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/getMaxExtendOrder', response.data.statusMessage);
                    return;
                }
                this.maxExtendOrder = response.data.count + 1;
                this.dialogGroupElementVisible = true;
            });
        },
        // 编辑扩展组元素
        btnEditGroupElement(row) {
            this.editItem = row;
            this.elementTitle = 'pgCommon.EDIT_ELEMENT';
            this.isAddElementData = false;
            this.dialogGroupElementVisible = true;

            this.groupId = this.templateKey + ':' + this.taskForm.taskKey;
            this.modelStr = this.templateId;
            this.modelKey = this.templateKey;
            this.taskKey = this.taskForm.taskKey;
            this.taskName = this.taskForm.taskName;
        },
        // 删除扩展组元素
        deleteGroupElement(row) {
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getDeleteParam(row);
                    extendGroupApi.deleteGroupElement(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteGroupElement', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 批量删除
        btnBatchDelElement() {
            this.batchDeleteLoading = true;
            let items = this.$refs.tableInfo.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('extendCommon.PLEASE_SELECT'), type: 'warning' });
                this.batchDeleteLoading = false;
                return;
            }
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: this.$t('extendCommon.CONFIRM'),
                cancelButtonText: this.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getDeleteParam();
                    extendGroupApi.deleteGroupElement(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.batchDeleteLoading = false;
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteGroupElement', response.data.statusMessage);
                            this.batchDeleteLoading = false;
                            return;
                        }
                        this.batchDeleteLoading = false;
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                    });
                })
                .catch(() => {
                    this.batchDeleteLoading = false;
                });
        },
        // 获取删除参数
        getDeleteParam(row) {
            let deleteParam = {
                sGroupId: this.templateKey + ':' + this.taskForm.taskKey,
                recordIdList: []
            };
            if (this.$util.isEmpty(row)) {
                // 批量删除
                let items = this.$refs.tableInfo.getSelectAllRows();
                for (let i = 0; i < items.length; i++) {
                    deleteParam.recordIdList.push(items[i].sId);
                }
            } else {
                // 单个删除
                deleteParam.recordIdList.push(row.sId);
            }
            return deleteParam;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 回调查询
        callbackQuery() {
            this.currentPage = 1;
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            var param = {
                sGroupId: this.templateKey + ':' + this.taskForm.taskKey
            };
            Api.listGroupElementInfo(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/listGroupElementInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/listGroupElementInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        // 编辑节点回显到单列表
        updateTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('modify', tableData);
        },
        // 添加节点回显到单列表
        addTableNode(tableData) {
            this.$refs.tdSingleList.updateTableData('add', tableData);
        },
        //获取排序后的表格数据，并更新数据库
        getSortData(oldIndex, newIndex, formatData) {
            for (let i = 0; i < formatData.length; i++) {
                formatData[i].iOrder = i + 1;
            }
            extendGroupApi.updateSortInfo(JSON.stringify(formatData), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('extendManage/updateSortInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/updateSortInfo', response.data.statusMessage);
                    return;
                }
            });
        },
        // 关闭dialogGroupVisible页面
        groupDialogClose() {
            this.dialogGroupVisible = false;
        },
        // 关闭dialogGroupElementVisible页面
        elementDialogClose() {
            this.dialogGroupElementVisible = false;
        },
        // 关闭dialogPreviewVisible页面
        previewDialogClose() {
            this.dialogPreviewVisible = false;
        },
        designDialogClose: function() {
            this.$emit('designDialogClose');
            this.dialogDesignVisible = false;
        }
    }
};
</script>
<style></style>
